import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Card } from '../SubscriptionAppCard';
import { formatShortDate } from '../../utils/dateFormat';
import { formatVisitTotal, sortVisitsNewestFirst } from '../../data/mockContactVisits';
import type { CellarDoorVisit } from '../../data/mockContactVisits';
interface CellarDoorVisitsCardProps {
  visits: CellarDoorVisit[];
}
const RECENT_COUNT = 5;

// The contact's most recent cellar door visits, logged from POS sales
export function CellarDoorVisitsCard({
  visits
}: CellarDoorVisitsCardProps) {
  const recent = sortVisitsNewestFirst(visits).slice(0, RECENT_COUNT);
  return <Card padding="none" data-id="element-1072" data-mp="1ajii47mbc0in">
      <div className="p-6 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-1073" data-mp="1aktomf757mdg">
        <div className="flex items-center justify-between gap-3" data-id="element-1074" data-mp="15pxkwhsjnaki">
          <h3 className="text-xl font-semibold text-[#0F172A]" data-id="element-1075" data-mp="i14v732ilyyc">
            Cellar door visits
          </h3>
          {visits.length > 0 && <button type="button" onClick={() => undefined} className="inline-flex items-center gap-1 flex-shrink-0 whitespace-nowrap text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-1076" data-mp="d18q10i301h7">
              View all
              <ArrowRight className="w-3.5 h-3.5" data-id="element-1077" data-mp="2r9gi8lz6oz4s" />
            </button>}
        </div>
        <p className="text-sm text-[#64748B] mt-1" data-id="element-1078" data-mp="2w91oziklibs2">
          {visits.length} {visits.length === 1 ? 'visit' : 'visits'}
        </p>
        <p className="text-xs text-[#94A3B8] mt-1" data-id="element-1079" data-mp="1zju6kjf9wisd">
          Recorded automatically from POS orders (order source = POS, with location). No staff action needed.
        </p>
      </div>
      {recent.length === 0 ? <div className="px-6 py-8 text-center text-sm text-[#64748B] bg-white rounded-b-lg" data-id="element-1080" data-mp="28ipcdueenqv5">
          No cellar door visits yet
        </div> : <ul className="bg-white rounded-b-lg divide-y divide-[#E2E8F0]" data-id="element-1081" data-mp="2dg7asqusqnow">
          {recent.map(visit => <li key={visit.id} className="px-6 py-4" data-id="element-1082" data-mp="3k0qdenuaqg3q">
              <div className="flex items-baseline justify-between gap-4" data-id="element-1083" data-mp="3ownvozp4dwj5">
                <span className="text-sm font-semibold text-[#0F172A]" data-id="element-1084" data-mp="2z9bgolfck9f2">
                  {formatShortDate(visit.date)}
                </span>
                <span className="text-sm font-semibold text-[#0F172A]" data-id="element-1085" data-mp="2u9yr3sx3co8s">
                  {formatVisitTotal(visit.saleTotal)}
                </span>
              </div>
              <div className="text-sm text-[#475569] mt-0.5" data-id="element-1086" data-mp="348ejs0bro5ke">
                {visit.location} · {visit.staff}
              </div>
            </li>)}
        </ul>}
    </Card>;
}